<template>
  <div ref="layout" class="page-container">
    <div class="query-title">经销商账款期初数据导入</div>

    <div class="content">
      <div class="table-container">
        <TableCommon
          title="导入数据"
          :custome-config="() => vxeShowCustom('xTable')"
        >
          <template #button>
            <table-button name="import" tip="导入" @click="handleImportExcel" />
            <table-button name="save" tip="保存" @click="handleSaveImportExcel" />
            <table-button name="download" tip="模板下载" @click="downloadTemplate('dealerInit')" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <!-- <template #toolbar /> -->
            <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
              <div :key="item.field">
                <span>{{ row[item.field] }}</span>
              </div>
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
    </div>

  </div>
</template>
<script>
import { apiExportExcelTemplate, apiExcelImport, apiGetExcelImportData } from '@/api/common'
import { apiDsImport } from '@/api/sap/dealer'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
export default {
  name: 'dealer-data-import',
  components: {
  },
  data() {
    return {
      rules: {},
      conditions: {
        templateCode: 'dealerInit',
        batchNumber: ''
      },
      pagination: {
        page: 1,
        pagesize: 10000,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          // { type: 'checkbox', title: '', filed: 'checkbox', width: 120 },
          {
            field: 'message',
            title: '消息'
          },
          {
            field: 'status_text',
            title: '状态'
          },
          {
            field: 'customer',
            title: '客户编号'
          },
          {
            field: 'account',
            title: '科目编号'
          },
          {
            field: 'account_txt',
            title: '科目名称'
          },
          {
            field: 'post_date',
            title: '过账日期'
          },
          {
            field: 'balance_amount',
            title: '余额'
          }
        ],
        data: []
      }
    }
  },
  created() {
    if (this.queryData) {
      this.queryData()
    }
  },
  methods: {
    // 模板下崽
    async downloadTemplate(type) {
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${res.data.file}&authToken=${getToken()}&fileName=经销商账款期初数据导入模版`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', '经销商账款期初数据导入模版')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    // 导入excel
    async handleImportExcel() {
      this.$refs.xTable.readFile({
        types: ['xlsx']
      }).then(async(resp) => {
        const { files } = resp
        const formData = new FormData()
        Array.from(files).forEach(file => {
          formData.append('file', file)
        })
        const params = {
          formData,
          templateCode: this.conditions.templateCode
        }
        const res = await apiExcelImport(params)
        if (res?.status === 1) {
          this.conditions.batchNumber = res.data
          this.handleQueryImportExcel()
        }
      })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.pagination
      const params = { ...this.conditions, page, pagesize }
      const res = await apiGetExcelImportData(params)
      for (const item of res.data.Rows) {
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          delete item[key]
        })
      }
      // 调用sap接口检查数据
      const params2 = {
        user_bp: this.$store.getters.role.USER_BP,
        info: res.data.Rows,
        mode: 'CHECK'
      }
      const res2 = await apiDsImport(params2)
      this.gridOptions.data = res2.data
    },
    // 驼峰转成下划线并且大写
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toUpperCase()
    },
    // 将导入临时表的数据保存到正式业务表
    async handleSaveImportExcel() {
      if (!this.gridOptions.data.length) return this.$message.warning('无有效数据！')
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        info: this.gridOptions.data,
        mode: 'SAVE'
      }
      const res = await apiDsImport(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        this.gridOptions.data = res.data
      } else {
        this.$message.error(res.message)
      }
    },
    handleTablePaginationChange() {}
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer-manage/dealerDataImport.vue